import type { NodeTypes } from "@xyflow/react";
import { SecurityOwnershipsGroupedByOwnedId } from "features/entities/EntityCreatePage/EntityGraph/entityGraphTypes";
import { DraftNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/DraftNode";
import {
  allNodeButDraft,
  getType,
} from "features/entities/EntityCreatePage/EntityGraph/nodes/nodeUtils";
import {
  AppNode,
  Entity,
} from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import values from "lodash-es/values";

export const getInitialNodes = (
  entities: Entity[],
  securitiesGroupedByInvestingInto: SecurityOwnershipsGroupedByOwnedId,
): AppNode[] => {
  const nodesWithLPsGrouped = [
    ...entities.filter((entity) => entity.functional_type !== "investor"),
    ...values(securitiesGroupedByInvestingInto).map(
      (group): Entity => ({
        id: group.investorsGroupId,
        functional_type: "investor" as const,
        legal_name: group.label,
      }),
    ),
  ];

  const nodes = nodesWithLPsGrouped.map((entity, index): AppNode => {
    const { type, backgroundColor } = getType(entity.functional_type);
    return {
      id: entity.id!,
      type,
      position: { x: index, y: index },
      data: {
        backgroundColor,
        label: entity.legal_name,
        entity,
      },
    };
  });

  return nodes;
};

export const nodeTypes = {
  ...allNodeButDraft,
  draft: DraftNode,
} as const satisfies NodeTypes;
